// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.root_tN6zb{margin:7.5rem 1.25rem}`, "",{"version":3,"sources":["webpack://./web/src/components/PageContainer/PageContainer.module.scss"],"names":[],"mappings":"AAGA,YACE,qBAAA","sourcesContent":["@use '../../styles/tokens' as *;\n@use '../../styles/mixins' as *;\n\n.root {\n  margin: rem(120) rem(20);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `root_tN6zb`
};
export default ___CSS_LOADER_EXPORT___;
